import { useQueryState } from "nuqs";

export function useConversationId() {
  return useQueryState("conversationId");
}
